import React from 'react';
import { Link } from 'gatsby';
import { Container } from './nav.css';

const Nav = () => (
  <Container>
    <ul>
      <li>
        <Link to="/about">About</Link>
      </li>
      <li>
        <Link to="/about2">About 2</Link>
      </li>
      <li>
        <Link to="/about3">About 3</Link>
      </li>
      <li>
        <a
          href="https://github.com/brisull"
          rel="noreferrer noopener"
          target="_blank"
        >
          GitHub
        </a>
      </li>
    </ul>
  </Container>
);

export default Nav;
